import { gql } from '@apollo/client';

const studentsAttentionCountQuery = gql`
  query StudentsAttentionCountQuery {
    studentsAttentionCountQuery {
      awaitingTrial
      needModule
      total
    }
  }
`;

export default studentsAttentionCountQuery;
